import { get, } from '.';

export function GetCities(options = {}) {
	return get<any>("/app/api/cities", options);
}
